const ProcrastinatedDays = ({ complete, created, pushed }) => {
  const dateCreated = new Date(created);
  const datePushed = new Date(pushed);
  const today = new Date();

  let difference = 0;
  if (datePushed > today) {
    difference = dateCreated.getTime() - datePushed.getTime();
  } else {
    difference = dateCreated.getTime() - today.getTime();
  }
  const days = -Math.ceil(difference / (1000 * 3600 * 24));

  if (complete === false) {
    if (days > 1) {
      return (
        <code className="procrastinated-days">
          <br></br>Procrastinated for {days} days
        </code>
      );
    } else if (days === 1) {
      return (
        <code className="procrastinated-days">
          <br></br>Procrastinated for 1 day
        </code>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default ProcrastinatedDays;
